module.exports = __webpack_public_path__ + "static/media/tbx.a9812c07.svg";